import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PageHeader1 from '../../components/common/PageHeader1';
import apiClient from '../../utils/api';
import { toast } from 'react-toastify';

function EnquiryDetail() {
    const { id } = useParams();
    const [enquiry, setEnquiry] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchEnquiry();
    }, [id]);

    const fetchEnquiry = async () => {
        try {
            const token = localStorage.getItem('auth_token');
            const response = await apiClient.get(`/accounts/enquiries/${id}`,{
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setEnquiry(response.data);
            setLoading(false);
        } catch (error) {
            toast.error('Failed to fetch enquiry details');
            setLoading(false);
        }
    };

    const updateStatus = async (status) => {
        try {
            await apiClient.patch(`/enquiries/${id}`, { status });
            fetchEnquiry();
            toast.success('Status updated successfully');
        } catch (error) {
            toast.error('Failed to update status');
        }
    };

    if (loading) return <div>Loading...</div>;
    if (!enquiry) return <div>Enquiry not found</div>;

    return (
        <div className="body d-flex py-3">
            <div className="container-xxl">
                <PageHeader1 pagetitle='Enquiry Details' />
                <div className="row g-3 mb-3">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <h5>Basic Information</h5>
                                        <div className="mb-3">
                                            <strong>Name:</strong> {enquiry.name}
                                        </div>
                                        <div className="mb-3">
                                            <strong>Email:</strong> {enquiry.email}
                                        </div>
                                        <div className="mb-3">
                                            <strong>Phone:</strong> {enquiry.phone}
                                        </div>
                                        <div className="mb-3">
                                            <strong>Status:</strong> 
                                            <select 
                                                className="form-select ms-2 d-inline-block w-auto"
                                                value={enquiry.status}
                                                onChange={(e) => updateStatus(e.target.value)}
                                            >
                                                <option value="new">New</option>
                                                <option value="in_progress">In Progress</option>
                                                <option value="completed">Completed</option>
                                                <option value="spam">Spam</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <h5>Additional Information</h5>
                                        <div className="mb-3">
                                            <strong>Created At:</strong> {new Date(enquiry.created_at).toLocaleString()}
                                        </div>
                                        <div className="mb-3">
                                            <strong>Source:</strong> {enquiry.source}
                                        </div>
                                        <div className="mb-3">
                                            <strong>IP Address:</strong> {enquiry.ip_address}
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-4">
                                    <div className="col-12">
                                        <h5>Message</h5>
                                        <div className="border p-3 rounded">
                                            {enquiry.message}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EnquiryDetail;